

























import Vue from 'vue';
import { ajax } from 'jquery';
import { BAlert } from 'bootstrap-vue';

import GenericCard from '@/components/cards/GenericCard.vue';
import { reload } from '@/utils';
import { ServerResponse } from './types';

export default Vue.extend({
  name: 'StopRecurrenceModal',
  components: {
    GenericCard,
    BAlert,
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    recApiUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      errors: <string[]>[],
    };
  },
  methods: {
    stopRecurrence() {
      ajax({
        type: 'DELETE',
        url: this.recApiUrl,
        contentType: 'application/json',
        headers: { 'X-CSRF-Token': this.csrfToken },
        success: (response: ServerResponse) => {
          if (response.errors && response.errors.length > 0) {
            this.errors = response.errors;
            return;
          }

          const refreshAfter = GGRC.zenModal.modals.length < 2;
          this.$emit('close');
          if (refreshAfter) {
            this.reload();
          }
        },
        error: () => {
          this.errors = ['Stopping recurrence failed.'];
        },
      });
    },
    reload,
  },
});
